import { render, staticRenderFns } from "./PrepaidFeeHistoryForm.vue?vue&type=template&id=013f0ec9&"
import script from "./PrepaidFeeHistoryForm.vue?vue&type=script&lang=js&"
export * from "./PrepaidFeeHistoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports